import React from 'react';

import { Color } from 'modules/styles/colors';
import { FontWeight } from 'modules/styles/variables';

import Spacer from 'components/UI/Layout/Spacer';
import PercentageBar from 'components/Triage/PercentageBar';
import { Icon } from 'components/Icon';

import { TriageCondition } from 'store/triageGyant/types';

import { getLikelihoodText } from 'lib/triage/utils';

import { MuiBox, MuiTypography, MuiDivider } from 'theme/material-ui';

interface Props {
  item: TriageCondition;
  index: number;
}

const CauseCard = ({ item, index }: Props) => {
  const title = `${index + 1}: ${item.conditionText}`;
  const percentage = item.likelihoodScore * 19.6; // Gyant gives 1 through 5. Shouldn't ever display 100%
  const likelihood = getLikelihoodText(item.likelihoodScore);
  return (
    <MuiBox data-testid={`Likely cause ${title}`}>
      <MuiBox flexDirection="row" display="flex" justifyContent="space-between">
        <MuiBox>
          <MuiTypography variant="h6">{title}</MuiTypography>
        </MuiBox>
        <MuiBox>
          <Icon name="keyboard-arrow-right" size={24} color={Color.gray} />
        </MuiBox>
      </MuiBox>

      <Spacer spacing="large" />
      <MuiDivider />
      <Spacer spacing="medium" />

      <PercentageBar percentComplete={percentage} />
      <MuiBox flexDirection="row" justifyContent="flex-end" display="flex">
        <MuiTypography
          fontWeight={index < 2 ? FontWeight.semibold : undefined}
          color={Color.primary}
        >
          {likelihood}
        </MuiTypography>
      </MuiBox>
    </MuiBox>
  );
};

export default React.memo(CauseCard);
